import { Component } from "@angular/core";

@Component({
	selector: "caass-portal-apps",
	templateUrl: "./portal-apps.component.html",
})
export class PortalAppsComponent {}
